// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5005) return "css/5005.d2f16645.chunk.css";
	// return url for filenames based on template
	return "css/" + {"16":"antd-vendor-931ab74b","5557":"index-63e4ae2f","5666":"antd-vendor-f79110f3","6862":"antd-vendor-7d0ccfb8","7411":"vendors-0bc0478e"}[chunkId] + "." + {"16":"91a3b4ac","5557":"2fa6ff59","5666":"566cf2bd","6862":"1f96624a","7411":"b160e05c"}[chunkId] + ".css";
};